import Vue from 'vue'
import Router from 'vue-router'
import AuthGuard from './auth-guard'
import VerifyPIN from '@/components/activation/VerifyPIN'
import AccountType from '@/components/activation/AccountType'
import PlanSelection from '@/components/activation/PlanSelection'
import PhoneNumberSelection from '@/components/activation/PhoneNumberSelection'
import NewActivation from '@/components/activation/NewActivation'
import BillingDetails from '@/components/billing/BillingDetails'
import Confirmation from '@/components/billing/Confirmation'
import Signin from '@/components/user/Signin'
import ForgotPassword from '@/components/user/ForgotPassword'
import ResetPassword from '@/components/user/ResetPassword'
import ResetEmailSent from '@/components/user/ResetEmailSent'
import VerifyEmail from '@/components/user/VerifyEmail'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/account-type'
    },
    {
      path: '/account-type',
      name: 'account-type',
      component: AccountType
    },
    {
      path: '/new-activation',
      name: 'new-activation',
      component: NewActivation
    },
    {
      path: '/verify-email',
      name: 'verify-email',
      component: VerifyEmail,
      props: true
    },
    {
      path: '/login/:timeout?',
      name: 'login',
      component: Signin
    },
    {
      path: '/forgot-password/:expired?',
      name: 'forgot-password',
      component: ForgotPassword
    },
    {
      path: '/reset-password/:token?',
      name: 'reset-password',
      component: ResetPassword
    },
    {
      path: '/reset-email-sent',
      name: 'reset-email-sent',
      component: ResetEmailSent
    },
    {
      path: '/verify-pin',
      name: 'verify-pin',
      component: VerifyPIN,
      beforeEnter: AuthGuard
    },
    {
      path: '/select-plan',
      name: 'select-plan',
      component: PlanSelection,
      beforeEnter: AuthGuard
    },
    {
      path: '/select-number',
      name: 'select-number',
      component: PhoneNumberSelection,
      beforeEnter: AuthGuard
    },
    {
      path: '/billing-details',
      name: 'billing-details',
      component: BillingDetails,
      beforeEnter: AuthGuard
    },
    {
      path: '/thank-you',
      name: 'thank-you',
      component: Confirmation,
      beforeEnter: AuthGuard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js